import * as actionTypes from './actionTypes';

import { healthData as healthDataSchema, arrayOfHealthData as arrayOfHealthDataSchema, normalize } from '../../helpers/schema';
import * as api from '../api';
import { createActionObject, getNoArgDispatcherFunc, getAjaxFunc } from '../../helpers/common';
import { ERROR_TYPE_NOT_CONNECTED } from '../constants';
import * as strings from '../../helpers/strings';

export const fetchErrorTypes = () => dispatch => api.fetchErrorType()
  .then(errorTypes => dispatch(
    createActionObject(
      actionTypes.FETCH_ERROR_TYPES_SUCCESS,
      { errorTypes }
    )
  ));

export const setInitialHealthData = stations => dispatch => {
  
  var stationHealths = stations.map(station => ({
    stationId: station.name,
    softwareType: 8,
    timestamp: null,
    errorType: ERROR_TYPE_NOT_CONNECTED
  }));
  
  dispatch(
    createActionObject(
      actionTypes.SET_INITIAL_HEALTH_DATA,
      normalize(stationHealths, arrayOfHealthDataSchema)
    )
  );
}

export const setHealthData = healthData => dispatch => {
  dispatch(
    createActionObject(
      actionTypes.SET_HEALTH_DATA,
      normalize(healthData, healthDataSchema)
    )
  ) 
}

export const setOfflineIntervalId = id => dispatch => dispatch(
  createActionObject(
    actionTypes.START_OFFLINE_INTERVAL,
    { id }
  )
);

export const clearOfflineIntervalId = getNoArgDispatcherFunc(actionTypes.STOP_OFFLINE_INTERVAL);

export const setErrorType = (stationId, errorType) => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_STATION_ERROR_TYPE,
    { stationId, errorType }
  )
)

export const fetchLatestHealthData = stations => dispatch => getAjaxFunc(
  actionTypes.FETCH_LATEST_DATA_REQUEST,
  "",
  actionTypes.FETCH_LATEST_DATA_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => {
    var stationIds = "";
    for(var i = 0; i < stations.length; i++){
      if(i)
        stationIds += ",";
      stationIds += stations[i].name;
    }

    return api.fetchLatestHealthData(stationIds, new Date().getFullYear())
    .then(({ status, data }) => {
      switch(status){
        case 200:
          var currentTimestamp = new Date().getTime();
          var newHealthArr = data.map(healthData => ({
            ...healthData,
            errorType: (currentTimestamp - healthData.timestamp) > 300000 ? ERROR_TYPE_NOT_CONNECTED : healthData.errorType
          }));
          dispatch(
            createActionObject(
              actionTypes.FETCH_LATEST_DATA_SUCCESS,
              normalize(newHealthArr, arrayOfHealthDataSchema)
            )
          );
          return newHealthArr;
        default:
          dispatch(
            createActionObject(
              actionTypes.FETCH_LATEST_DATA_FAILURE,
              { message: strings.msgUnknownErrorOccured }
            )
          );
          return null;
      }
    });
  }
)();

export const selectStation = stationId => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_STATION,
    { stationId }
  )
)

export const filterStatus = filterId => dispatch => dispatch(
  createActionObject(
    actionTypes.FILTER_STATUS,
    { filterId }
  )
)

export const fetchLatestPRData = (payload) => dispatch => {
  api.fetchLatestPRData(payload)
    .then(({ data, status }) => {
      if (status === 200) {
        const byId = data.reduce((acc, item) => {
          acc[item.station] = {
            ...acc[item.station],
            description: item.description,
            prData: item.annualPerformanceRatio,
            systemCapacity: item.systemCapacity
          };
          return acc;
        }, {});
        dispatch(
          createActionObject(
            actionTypes.SET_PR_DATA,
            { byId }
          )
        );
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.SET_PR_DATA,
            { byId: {} }
          )
        );
      }
    })
    .catch(error => {
      console.error("Error fetching latest PR data:", error);
      dispatch(
        createActionObject(
          actionTypes.SET_PR_DATA,
          { byId: {} }
        )
      );
    });
};

export const clearLatestPRData = () => createActionObject(actionTypes.CLEAR_PR_DATA);